import { computed, toValue } from "vue";
import { createModifiers } from "./classes";

/**
 * A composable to create modifiers based on the props and the keys with values.
 *
 * @example
 * props: {
 *  size: "sm",
 *  color: "red",
 * }
 * const { modifiers } = useModifiers(props, "size", "color");
 * modifiers.value // ["--size-sm", "--color-red"]
 *
 * @param {Object} props
 * @param  {...String} keys
 * @returns Object
 * @property {import("vue").ComputedRef<string[]>} modifiers
 */
export function useModifiers(props, ...keys) {
  const modifiers = computed(() => createModifiers(toValue(props), keys, { withValue: true }));

  return {
    modifiers,
  };
}

/**
 * A composable to create modifiers based on the props and the keys.
 *
 * @example
 * props: {
 *   icon: true,
 * }
 * const { booleanModifiers } = useBooleanModifiers(props, "icon");
 * booleanModifiers.value // ["--icon"]
 *
 * @param {Object} props
 * @param  {...String} keys
 * @returns Object
 * @property {import("vue").ComputedRef<string[]>} booleanModifiers
 */
export function useBooleanModifiers(props, ...keys) {
  const booleanModifiers = computed(() => createModifiers(props, keys));

  return {
    booleanModifiers,
  };
}
